import FeaturedDocuments from './featured_documents';
import initializeComponent from 'Shared/react-initialize';

initializeComponent('FeaturedDocuments', FeaturedDocuments);
